import { useMemo } from 'react';
import { useRbTexts } from '../../../remote-state/applicationHooks';
import { PlaceholderValues } from '../constants';

export function usePlaceholderValues() {
  const texts = useRbTexts();

  return useMemo(() => ({
    NotAvailable: texts?.['spaces.integrations.fields.notAvailable'] || PlaceholderValues.NotAvailable,
    CreationTimestamp: PlaceholderValues.CreationTimestamp,
    ClosingTimestamp: PlaceholderValues.ClosingTimestamp,
    ModificationTimestamp: PlaceholderValues.ModificationTimestamp,
    Select: texts?.['spaces.integrations.fields.select'] || PlaceholderValues.Select,
    TypeHere: texts?.['spaces.integrations.fields.typeHere'] || PlaceholderValues.TypeHere,
    NoEditingPermissions: texts?.['spaces.integrations.fields.noEditingPermissions'] || PlaceholderValues.NoEditingPermissions,
    ReadOnlyNumber: PlaceholderValues.ReadOnlyNumber,
    NotFound: texts?.['spaces.field.tooltip.notInTemplate'] || 'Field not found in template'
  }), [texts]);
}